import { createSlice } from "@reduxjs/toolkit";
import api from "../../../api/whiteboards/share";
import apiBoard from "../../../api/whiteboards/resource";
import cloneDeep from 'lodash/cloneDeep';

export const fetchWhiteboardShare = (params) => async (dispatch, getState) => {
    const currentBoardId = cloneDeep(getState().whiteboardShareList.boardId)
    if (currentBoardId) {
        dispatch(setStatus("loading"));
        try {
            if(currentBoardId){
                const response = await api.index({
                    ...params,
                    boardId: currentBoardId
                });
                dispatch(setWhiteboardShares(response.data.filter(wbp => wbp.white_board_permission_id)));
                dispatch(setSharedUserIds(response.userIds));
                dispatch(setMeta(response.meta));
                dispatch(setStatus("success"));
            }
        } catch (e) {
            // dispatch(setStatus("failed"));
            if(e.response.status === 403){
                window.location = '/home/manager-whiteboard';
            }
            // navigate(`/home/manager-whiteboard/share-management/${board.white_board_id}`)
        }finally {
            dispatch(setCurrentAction(""));
            dispatch(setStatus("waiting"));
        }
    }
};

export const addWhiteboardShare = (params) => async (dispatch, getState) => {
    dispatch(setCurrentAction("create"));
    dispatch(setWhiteboardShareStatus("loading"));
    try {
        await api.store({
            ...params,
            boardId: cloneDeep(getState().whiteboardShareList.boardId)
        });
        dispatch(setWhiteboardShareStatus("success"));
    } catch (e) {
        dispatch(setWhiteboardShareStatus("failed"));
        if(e.response.status === 403){
            window.location = '/home/manager-whiteboard';
        }
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
    }
};

export const getWhiteboard = () => async (dispatch, getState) => {
    const currentBoardId = cloneDeep(getState().whiteboardShareList.boardId)
    if (currentBoardId) {
        dispatch(setCurrentAction("fetch"));
        dispatch(setStatus("loading"));
        try {
            if(currentBoardId){
                const board = await apiBoard.get(currentBoardId);
                dispatch(setWhiteBoard(board));
                dispatch(setStatus("success"));
            }else{
                dispatch(setCurrentAction(""));
            }
        } catch (e) {
            dispatch(setStatus("failed"));
            if(e.response.status === 403){
                window.location = '/home/manager-whiteboard';
            }
        } finally {
            dispatch(setCurrentAction(""));
            dispatch(setStatus("waiting"));
        }
    }
};

export const updateWhiteboardShare = (id, params) => async (dispatch, getState) => {
    dispatch(setCurrentAction("update"));
    dispatch(setWhiteboardShareStatus("loading"));
    try {
        await api.update(cloneDeep(getState().whiteboardShareList.boardId), id, params);
        dispatch(setWhiteboardShareStatus("success"));
    } catch (e) {
        dispatch(setWhiteboardShareStatus("failed"));
        if(e.response.status === 403){
            window.location = '/home/manager-whiteboard';
        }
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
    }
};

export const updateWhiteboardShareMultiple = (params) => async (dispatch, getState) => {
    dispatch(setCurrentAction("update"));
    dispatch(setWhiteboardShareStatus("loading"));
    try {
        await api.updateMultiple(cloneDeep(getState().whiteboardShareList.boardId), params);
        dispatch(setWhiteboardShareStatus("success"));
    } catch (e) {
        dispatch(setWhiteboardShareStatus("failed"));
        if(e.response.status === 403){
            window.location = '/home/manager-whiteboard';
        }
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
    }
};


export const deleteWhiteboardShares = (ids) => async (dispatch, getState) => {
    dispatch(setCurrentAction("update"));
    dispatch(setWhiteboardShareStatus("loading"));
    try {
        await api.deleteMultiple(cloneDeep(getState().whiteboardShareList.boardId), ids);
        dispatch(setWhiteboardShareStatus("success"));
    } catch (e) {
        dispatch(setWhiteboardShareStatus("failed"));
        if(e.response.status === 403){
            window.location = '/home/manager-whiteboard';
        }
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
    }
};

export const deleteWhiteboardAllShares = () => async (dispatch, getState) => {
    dispatch(setCurrentAction("update"));
    dispatch(setWhiteboardShareStatus("loading"));
    try {
        await api.deleteAll(cloneDeep(getState().whiteboardShareList.boardId));
        dispatch(setWhiteboardShareStatus("success"));
    } catch (e) {
        dispatch(setWhiteboardShareStatus("failed"));
        if(e.response.status === 403){
            window.location = '/home/manager-whiteboard';
        }
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
    }
};

const initialState = {
    status: "waiting",
    whiteboardShareStatus: "waiting",
    currentAction: '',
    whiteboardShares: [],
    sharedUserIds: [],
    boardId: null,
    whiteboard: null,
    meta: {
        total: null,
        per_page: null,
        last_page: null,
        page: null,
        filter: {
            username: null
        },
        data: [],
    },
};

const whiteboardShareList = createSlice({
    name: "whiteboardShareList",
    initialState,
    reducers: {
        setWhiteboardShares: (state, action) => {
            state.whiteboardShares = action.payload;
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        setWhiteboardShareStatus: (state, action) => {
            state.whiteboardShareStatus = action.payload;
        },
        setCurrentAction: (state, action) => {
            state.currentAction = action.payload;
        },
        setMeta: (state, action) => {
            state.meta = { ...state.meta, ...action.payload };
        },
        setBoardId: (state, action) => {
            state.boardId = action.payload;
        },
        setWhiteBoard: (state, action) => {
            state.whiteboard = action.payload;
        },
        setSharedUserIds: (state, action) => {
            state.sharedUserIds = action.payload;
        }

    },
});

export const {
    setWhiteboardShares,
    setMeta,
    setStatus,
    setWhiteboardShareStatus,
    setCurrentAction,
    setBoardId,
    setWhiteBoard,
    setSharedUserIds
} = whiteboardShareList.actions;
export default whiteboardShareList.reducer;